import { call, takeEvery, take } from 'redux-saga/effects';
import { ADD_USER_UPLOAD_IMAGE_TO_CANVAS, ADD_USER_IMAGE_TO_SCRIBE } from 'JS/actionCreators/imagesActions';
import {
  TRACK_IMAGE_IMPORT_CLICK,
  TRACK_IMAGE_LIBRARY_CLICK,
  TRACK_IMAGE_SEARCH
} from 'JS/actionCreators/trackingActions';
import { UPDATE_SCRIBE, SET_ACTIVE_ELEMENTS } from 'JS/actionCreators/scribeActions';
import { userImageLibrary } from 'JS/shared/resources/userImageLibrary';

import { track } from '../mixpanelProvider';

function* trackImageElementCreatedFromUpload({ file, scribeId, uploadMethod }) {
  const props = {
    'Image Name': file.name,
    'Image Source': 'user',
    'Scribe ID': scribeId,
    'File Type': file.type,
    'Image size': file.size,
    'Upload Method': uploadMethod
  };
  yield call(track, 'Add Image To Canvas', props);
}

function* trackImageElementCreatedFromLibrary({ scribeId, imageType, provider, imageId, selectedLibrary }) {
  const { elementIds } = yield take(SET_ACTIVE_ELEMENTS);
  const { scribe: updatedScribe } = yield take(UPDATE_SCRIBE);
  const element = updatedScribe.elements.find(el => el.id === elementIds[0]);

  const props = {
    'Image Name': element.image?.filename,
    'Image ID': imageId,
    'Image Source': provider,
    'Scribe ID': scribeId,
    'File Type': imageType,
    Category: selectedLibrary?.title || userImageLibrary,
    'Colour Change': element.recolorAvailable
  };
  yield call(track, 'Add Image To Canvas', props);
}

function* trackImageImportClick({ scribeId }) {
  yield call(track, 'Open Image Upload', { 'Scribe ID': scribeId });
}

function* trackImageLibraryClick({ library, scribeId }) {
  yield call(track, 'Select Image Category', { 'Scribe ID': scribeId, Category: library.title });
}

function* trackSearchImage({ query, scribeId }) {
  yield call(track, 'Search For Image', { 'Scribe ID': scribeId, 'Search Term': query });
}

export default function* trackImagesSagas() {
  yield takeEvery(TRACK_IMAGE_IMPORT_CLICK, trackImageImportClick);
  yield takeEvery(ADD_USER_UPLOAD_IMAGE_TO_CANVAS, trackImageElementCreatedFromUpload);
  yield takeEvery(ADD_USER_IMAGE_TO_SCRIBE, trackImageElementCreatedFromLibrary);
  yield takeEvery(TRACK_IMAGE_LIBRARY_CLICK, trackImageLibraryClick);
  yield takeEvery(TRACK_IMAGE_SEARCH, trackSearchImage);
}
